// src/pages/MS/MSU101F1.jsx
import React, {useEffect, useState} from 'react';
import style from "./MSU101F1.module.scss";
import {postData} from "utils/TransactionUtil";
import DataGrid from "components/DataGrid/DataGrid";
import Modal from "components/Modal/Modal";
import MSU101F2 from "pages/MS/MSU101F2";  //상세화면
import Modal2 from "components/Modal/Modal";
import MSU101F3 from "pages/MS/MSU101F3";  //신규등록
import Button from "../../components/Button/Button";
import Icon from "../../components/Icon/Icon";


const ButtonFormatter = ({ row }) => {
    if(row.modInfo) {
        return (
            <button title={row.modInfo}>
                <Icon id="edit_01" width="16" height="17"/>
            </button>
        );
    }
    return null;
};


const MSU101F1 = ({navBar: NavBar}) => {

    //검색 조건
    const [schUserNm, setSchUserNm] = useState('');

    //사용자리스트
    const [rows_UserList, setRows_UserList] = useState([]);
    const cols_UserList = [
        { key: 'sqnc',       name: 'NO',          width: '10%', renderCell: ({ rowIdx }) => rowIdx+1},
        { key: 'hsptNm',     name: '소속기관',     width: '15%' },
        { key: 'lginId',     name: '사용자ID',     width: '10%' },
        { key: 'userNm',     name: '사용자명',     width: '10%' },
        { key: 'roleNm',     name: '역할(그룹)',   width: '10%', cellClass: 'align_left' },
        { key: 'useYn',      name: '사용여부',     width: '10%', },
        { key: 'userDscr',   name: '사용자 설명',   width: '35%', cellClass: 'align_left' },
        // { key: 'tlno',       name: '전화번호',     width: '10%' },
        // { key: 'clno',       name: '핸드폰',       width: '10%' },
        // { key: 'emailId',    name: '이메일',       width: '10%' },
        // { key: 'lastLginDt', name: '마지막로그인',  width: '10%' },
        //{ key: 'modInfo',    name: '수정정보',     width: '5%', renderCell: ButtonFormatter}
    ];

    const [selLginId, setSelLginId] = useState();

    const [isModalOpen, setIsModalOpen] = useState(false); //모달 오픈여부(사용자 상세)
    const [isModal2Open, setIsModal2Open] = useState(false); //모달 오픈여부(사용자 상세)

    useEffect(() => {

        getUserList(); //그룹 공통 코드 조회

    }, []);

    const handleClick_search = () => {
        getUserList().then(r => {});
    }

    // 검색값 입력후 엔터
    const handleKeyDown_schUserNm = (e) => {
        //e.preventDefault();

        if (e.key === 'Enter') {
            getUserList().then(r => {});
        }
    };
 
    //공통 코드 그룹 조회
    async function getUserList(){
         const param = {
            schUserNm : schUserNm
        }
        const res = await postData("/MSU/getUserList", param);
        setRows_UserList(res);
    }

    //사용자 리스트 더블 클릭
    const handleDblClick_UserList = (e) => {
        setSelLginId(e.row.lginId); // 팝업으로 전송할 사용자 ID 셋팅
        setIsModalOpen(true);
    }

    //사용자 상세 팝업 닫기
    const handleModal_Close = () => {
        //e.preventDefault();
        setIsModalOpen(false);
    }

    //신규등록 닫기
    const handleModal2_Close = (result=0) => {
        setIsModal2Open(false);
        if(result===1){
            handleClick_search();
        }

    }


    /* Event **************************************/
    const btnClick_regUser = (e) => {
        // setSelLginId(e.row.lginId); // 팝업으로 전송할 사용자 ID 셋팅
         setIsModal2Open(true);
    }


    return(
        <main className={style.main_wrap}>
            <NavBar>
                {/*검색영역*/}
                <div className={style.search_wrap}>
                    <input
                        type="text"
                        className={style.schUserNm}
                        defaultValue={schUserNm}
                        onChange={(e) => setSchUserNm(e.target.value)}
                        name="schUserNm"
                        maxLength={'12'}
                        placeholder="사용자명 또는 ID 검색"
                        onKeyDown={(e) => handleKeyDown_schUserNm(e)}
                    />
                    <Button variant="Secondary" size="md" addStyle={{width: "82px", height: "40px"}}
                            onClick={() => handleClick_search()}>
                        조회<Icon id="rightAngleBrackets_02" width="16" height="16"/>
                    </Button>
                </div>
            </NavBar>
            {/*내용*/}
            <div className={style.main_cont}>
                <div className={style.info_grp}>
                    <h3>조회결과</h3><label>[총<span>{rows_UserList.length}건</span>]</label>
                    <div className={style.btn_grp}>
                        <Button variant="Outline" size="sm" addStyle={{width: "120px", height: "32px"}}
                                onClick={() => btnClick_regUser()}>신규 사용자 등록 </Button>

                    </div>
                </div>
                <div className={style.grad_wrap}>
                    <DataGrid
                        cols={cols_UserList}
                        rows={rows_UserList}
                        size='md'
                        headerRowHeight={37}
                        rowHeight={37}
                        onCellDoubleClick={(e) => handleDblClick_UserList(e)}
                        sortable={true}
                        isNodataView={true}
                        isRowColorful={false}
                    />
                </div>
            </div>
            <Modal
                open={isModalOpen}
                handle_Close={handleModal_Close}
                title="사용자관리 상세"
                width ="736px"
                height="850px"
                isHeader={true}
                //bottomBtnText={{cancel:"취소텍스트",confirm:"확인 텍스트"}}
                bottomBtnText={{cancel:"취소",confirm:"확인(적용)"}}
                isBottom={true}>
                <MSU101F2 handle_Close={handleModal_Close} selLginId={selLginId}/>
            </Modal>
            <Modal2
                open={isModal2Open}
                handle_Close={handleModal2_Close}
                title="신규 사용자 등록"
                width ="736px"
                height="850px"
                isHeader={true}
                bottomBtnText={{cancel:"취소",confirm:"저장"}}
                isBottom={true}>
                <MSU101F3 handle_Close={handleModal2_Close}/>
            </Modal2>
        </main>
    )
}
export default MSU101F1;
